module.exports = __webpack_public_path__ + "pc/img/rec_22.9cabee5a.svg";